import { render, staticRenderFns } from "./FollowerFormEmail.vue?vue&type=template&id=c7125b48&scoped=true&"
import script from "./FollowerFormEmail.vue?vue&type=script&lang=js&"
export * from "./FollowerFormEmail.vue?vue&type=script&lang=js&"
import style0 from "./FollowerFormEmail.vue?vue&type=style&index=0&id=c7125b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7125b48",
  null
  
)

export default component.exports